<template>
    <div v-show="!hidden" class="chartbar-menu" @wheel.stop @mouseenter="$emit('diableMapDragAndZoom')"
    @mouseleave="$emit('enableMapDragAndZoom')">
      <div class="title-bar"  @mousedown="startDrag">
        <span>图表信息</span> <!-- 这里可以修改标题内容 -->
        <div class="close-button" @click="$emit('closeChartMenu')">×</div>
      </div>
      <!-- 显示统计信息 -->
      <div v-show="chartInfo" class="menu-content">
        <!-- 基本信息 -->
        <div>
          <h3 class="info-title" @click="toggleSection('basicInfo')">
            基本信息
            <span>{{ sectionVisibility.basicInfo ? '[-]' : '[+]' }}</span>
          </h3>
          <div class="info-content" v-show="sectionVisibility.basicInfo">
            <p>基本情况 <span>
              <input type="radio" id="count1" name="jbsx" value="count1" v-model="xcUnit" @change="xcUnitChange">
              <label for="count1">数量</label>
              <input type="radio" id="area1" name="jbsx" value="area1" v-model="xcUnit" @change="xcUnitChange">
              <label for="area1">面积亩</label></span>
            </p>   
            <div ref="xc_chart" style="width:100%; height: 18vh;">
            </div>        
          </div>
          <!-- 可以根据实际情况添加更多基本信息 -->
        </div>
        <!-- 巡查信息 -->
        <div>
          <h3 class="info-title" @click="toggleSection('rectificationInfo')">
            种植信息
            <span>{{ sectionVisibility.rectificationInfo ? '[-]' : '[+]' }}</span>
          </h3>
          <div class="info-content" v-show="sectionVisibility.rectificationInfo">
            <p>种植信息：<span>
              <input type="radio" id="count2" name="zzsx" value="count2" v-model="zzUnit" @change="zzUnitChange">
              <label for="count2">数量</label>
              <input type="radio" id="area2" name="zzsx" value="area2" v-model="zzUnit" @change="zzUnitChange">
              <label for="area2">面积亩</label></span>
            </p> 
            <div ref="zz_chart" style="width:100%; height: 18vh;">
            </div> 
          </div>
        </div>
        <div>
          <h3 class="info-title" @click="toggleSection('inspectionInfo')">
            问题信息
            <span>{{ sectionVisibility.inspectionInfo ? '[-]' : '[+]' }}</span>
          </h3>
          <div class="info-content" v-show="sectionVisibility.inspectionInfo">
            <p>问题情况<span>
              <input type="radio" id="count3" name="wtsx" value="count3" v-model="wtUnit" @change="wtUnitChange">
              <label for="count3">数量</label>
              <input type="radio" id="area3" name="wtsx" value="area3" v-model="wtUnit" @change="wtUnitChange">
              <label for="area3">面积亩</label></span>
            </p>   
            <div ref="wt_chart" style="width:100%; height: 18vh;">
            </div>     
          </div>
        </div>
        <!-- 巡查信息 -->
        
      </div>      
    </div>
    
  </template>
  
  <script>
    import * as echarts from 'echarts';

  export default {
    name: 'StatisticalChart',
    props:{
      chartInfo:{
          type:Object,
          default:null,
      },
      hidden:{
          type:Boolean,
          default:false,
      },
      levelSet:{
        type:Object,
        default:null,
      }
    },
    data() {
      return {
        isDragging: false,
        startX: 0,
        startY: 0,
        offsetX: 0,
        offsetY: 0,
        sectionVisibility: {
          basicInfo: true,
          inspectionInfo: true,
          rectificationInfo: true
        },
        xcChart:null,
        wtChart:null,
        zzChart:null,

        xcUnit:'count1',
        zzUnit:'count2',
        wtUnit:'count3',
      };
    },
    
    methods: {
      xcUnitChange(){ //切换单位        
        if(this.xcUnit=='count1'){
          this.updateChartData(0,this.chartInfo.xcInfo.xdata,this.chartInfo.xcInfo.ydata,this.chartInfo.xcInfo.label);
        }else if(this.xcUnit=='area1'){         
          this.updateChartData(0,this.chartInfo.xcInfo.xdata1,this.chartInfo.xcInfo.ydata1,this.chartInfo.xcInfo.label);
        }
      },

      zzUnitChange(){ //切换单位        
        if(this.zzUnit=='count2'){
          this.updateChartData(1,this.chartInfo.zzInfo.xdata,this.chartInfo.zzInfo.ydata,this.chartInfo.zzInfo.label);
        }else if(this.zzUnit=='area2'){         
          this.updateChartData(1,this.chartInfo.zzInfo.xdata1,this.chartInfo.zzInfo.ydata1,this.chartInfo.zzInfo.label);
        }
      },

      wtUnitChange(){ //切换单位        
        if(this.wtUnit=='count3'){
          this.updateChartData(2,this.chartInfo.wtInfo.xdata,this.chartInfo.wtInfo.ydata,this.chartInfo.wtInfo.label);
        }else if(this.wtUnit=='area3'){         
          this.updateChartData(2,this.chartInfo.wtInfo.xdata1,this.chartInfo.wtInfo.ydata1,this.chartInfo.wtInfo.label);
        }
      },

      updateComponent(){  //更新组件 
          if(!this.xcChart){
            this.initChart();            
          }          
          if(this.chartInfo && this.chartInfo.xcInfo){                                     
                this.xcChart.setOption({
                    grid:{
                      left:'12%',
                      right:'2%',
                      top:'15%',
                      bottom:'40%',
                    },                    
                    xAxis: {
                        type: 'category',
                        data: this.xcUnit == "count1" ? this.chartInfo.xcInfo.xdata:this.chartInfo.xcInfo.xdata1,
                        axisLabel: {
                            rotate: 90, // 文字旋转 90 度，竖排显示
                            overflow: 'break', // 文字溢出处理方式，break 会换行显示
                            interval: 0, // 强制显示所有标签
                            color:'black',
                            fontSize:12
                            }
                        },
                    yAxis: {
                        type: 'value'
                        },
                    series:[{
                            name:this.chartInfo.xcInfo.label,
                            data:this.xcUnit == "count1"?this.chartInfo.xcInfo.ydata:this.chartInfo.xcInfo.ydata1,
                            type:'bar',
                            label: {
                                  rotate: 90, // 文字旋转 90 度，竖排显示
                                  align:'left',
                                  fontSize: 8, // 标签字体大小
                                  color:'blue',// 标签颜色
                                  show: true, // 显示标签
                                  position: 'top', // 标签位置在柱子顶部
                                  formatter: function(params){
                                    return Number.isInteger(params.value) ? params.value : params.value.toFixed(2);
                                  }, // 格式化标签内容，{c} 表示数据值
                                }
                              },                        
                          ],
                    legend: {
                        orient: 'horizontal', // 图例布局为水平方向
                        right: '2%', // 距离容器右侧 5%
                        top: '2%' // 距离容器顶部 5%
                    },
                });
            } 
            if(this.chartInfo && this.chartInfo.zzInfo){                               
                this.zzChart.setOption({
                    grid:{
                      left:'10%',
                      right:'2%',
                      top:'15%',
                      bottom:'40%',
                    },                    
                    xAxis: {
                        type: 'category',
                        data: this.zzUnit == "count2" ? this.chartInfo.zzInfo.xdata:this.chartInfo.zzInfo.xdata1,
                        axisLabel: {
                            rotate: 90, // 文字旋转 90 度，竖排显示
                            overflow: 'break', // 文字溢出处理方式，break 会换行显示
                            interval: 0, // 强制显示所有标签
                            color:'black',
                            fontSize:12
                            }
                        },
                    yAxis: {
                        type: 'value'
                        },
                    series:[{
                            name:this.chartInfo.zzInfo.label,
                            data:this.zzUnit == "count2"?this.chartInfo.zzInfo.ydata:this.chartInfo.zzInfo.ydata1,
                            type:'bar',
                            label: {
                              rotate: 90, // 文字旋转 90 度，竖排显示
                              align:'left',
                              fontSize: 8, // 标签字体大小
                              color:'blue',// 标签颜色
                              show: true, // 显示标签
                              position: 'top', // 标签位置在柱子顶部
                              formatter: function(params){
                                return Number.isInteger(params.value) ? params.value : params.value.toFixed(2);
                              }, // 格式化标签内容，{c} 表示数据值
                            }
                        },                        
                    ],
                    legend: {
                      orient: 'horizontal', // 图例布局为水平方向
                        right: '2%', // 距离容器右侧 5%
                        top: '2%' // 距离容器顶部 5%
                    },
                });
            } 
            if(this.chartInfo && this.chartInfo.wtInfo){                               
                this.wtChart.setOption({
                    grid:{
                      left:'10%',
                      right:'2%',
                      top:'15%',
                      bottom:'40%',
                    },                    
                    xAxis: {
                        type: 'category',
                        data: this.wtUnit == "count3" ? this.chartInfo.wtInfo.xdata:this.chartInfo.wtInfo.xdata1,
                        axisLabel: {
                            rotate: 90, // 文字旋转 90 度，竖排显示
                            overflow: 'break', // 文字溢出处理方式，break 会换行显示
                            interval: 0, // 强制显示所有标签
                            color:'black',
                            fontSize:12
                            }
                        },
                    yAxis: {
                        type: 'value'
                        },
                    series:[{
                            name:this.chartInfo.wtInfo.label,
                            data:this.wtUnit == "count3"?this.chartInfo.wtInfo.ydata:this.chartInfo.wtInfo.ydata1,
                            type:'bar',
                            label: {
                            rotate: 90, // 文字旋转 90 度，竖排显示
                            align:'left',
                            fontSize: 8, // 标签字体大小
                            color:'blue',// 标签颜色
                            show: true, // 显示标签
                            position: 'top', // 标签位置在柱子顶部
                            formatter: function(params){
                              return Number.isInteger(params.value) ? params.value : params.value.toFixed(2);
                            }, // 格式化标签内容，{c} 表示数据值
                          }
                        },                        
                    ],
                    legend: {
                      orient: 'horizontal', // 图例布局为水平方向
                      right: '2%', // 距离容器右侧 5%
                      top: '2%' // 距离容器顶部 5%
                    },
                });
            }            
         // this.$forceUpdate();
      },

      updateChartData(chartIndex,xdata,ydata,label,){  //更新数据        
        let tmpChart = null;
        if(chartIndex === 2){
          tmpChart = this.wtChart;
        }else if(chartIndex === 1){
          tmpChart = this.zzChart;
        }else if(chartIndex === 0){
          tmpChart = this.xcChart;
        } 
        if(tmpChart){          
          tmpChart.setOption({
            grid:{
                left:'12%',
                right:'2%',
                top:'15%',
                bottom:'40%',
            },      
            xAxis:{
              type: 'category',
              data: xdata,
              axisLabel: {
                rotate: 90, // 文字旋转 90 度，竖排显示
                overflow: 'break', // 文字溢出处理方式，break 会换行显示
                interval: 0 // 强制显示所有标签
              }                
            },
            yAxis: {
                type: 'value'
            },
            series:[{
                    name:label,
                    data:ydata,
                    type:'bar',
                    label: {    
                      rotate: 90, // 文字旋转 90 度，竖排显示
                      align:'left',
                      fontSize: 8, // 标签字体大小
                      color:'blue',// 标签颜色
                      show: true, // 显示标签
                      position: 'top', // 标签位置在柱子顶部
                      formatter: function(params){
                        return Number.isInteger(params.value) ? params.value : params.value.toFixed(2);
                      }, // 格式化标签内容，{c} 表示数据值
                    }
                },                        
            ],            
            legend: {
                  orient: 'horizontal', // 图例布局为水平方向
                  right: '5%', // 距离容器右侧 5%
                  top: '2%' // 距离容器顶部 5%
              },
          },true);
        }
      },

      resetChartData(chartIndex,xdata,ydata,label){  //重新赋值   
        let tmpChart = null;
        if(chartIndex === 1){
          tmpChart = this.wtChart;
        }else if(chartIndex === 2){
          tmpChart = this.zzChart;
        }else if(chartIndex === 0){
          tmpChart = this.xcChart;
        } 

        if(tmpChart){
          tmpChart.setOption({
              grid:{
                  left:'8%',
                  right:'2%',
                  top:'8%',
                  bottom:'35%',
              },                    
              xAxis: {
                  type: 'category',
                  data: xdata,
                  axisLabel: {
                      rotate: 90, // 文字旋转 90 度，竖排显示
                      overflow: 'break', // 文字溢出处理方式，break 会换行显示
                      interval: 0 // 强制显示所有标签
                      }
                  },
              yAxis: {
                  type: 'value'
                  },
              series:[{
                      name:label,
                      data:ydata,
                      type:'bar',
                      label: {
                          show: true, // 显示标签
                          position: 'top', // 标签位置在柱子顶部
                          formatter: '{c}', // 格式化标签内容，{c} 表示数据值
                          textStyle:{
                              fontSize:10,
                              color:'blue'
                          }
                      }
                  },                  
              ],
              legend: {
                  orient: 'horizontal', // 图例布局为水平方向
                  right: '5%', // 距离容器右侧 5%
                  top: '3%' // 距离容器顶部 5%
              },
          },true);   
        }
      },
      initChart(){
        this.xcChart = echarts.init(this.$refs.xc_chart);        
        this.wtChart = echarts.init(this.$refs.wt_chart);
        this.zzChart = echarts.init(this.$refs.zz_chart);
      },
      startDrag(event) {
        event.stopPropagation(); // 阻止事件冒泡
        this.isDragging = true;
        this.startX = event.clientX;
        this.startY = event.clientY;
        this.offsetX = this.$el.offsetLeft;
        this.offsetY = this.$el.offsetTop;
        document.addEventListener('mousemove', this.drag);
        document.addEventListener('mouseup', this.stopDrag);
      },
      drag(event) {
        event.stopPropagation(); // 阻止事件冒泡
        if (this.isDragging) {
          const dx = event.clientX - this.startX;
          const dy = event.clientY - this.startY;
          this.$el.style.left = `${this.offsetX + dx}px`;
          this.$el.style.top = `${this.offsetY + dy}px`;
        }
      },
      stopDrag() {
        this.isDragging = false;
        document.removeEventListener('mousemove', this.drag);
        document.removeEventListener('mouseup', this.stopDrag);
      },
      
      toggleSection(section) {
        this.sectionVisibility[section] = !this.sectionVisibility[section];       
      },        
    }
  };
  </script>
  
  <style scoped>
  .chartbar-menu {
    position: fixed;
    top: 15vh;
    left: 20px;
    width: 400px; /* 可以根据需要调整宽度 */
    height: 80vh;
    background-color: #f0f0f0; /* 可以根据需要调整背景颜色 */
    padding: 10px;
    box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1); /* 添加阴影效果 */
    z-index: 1002;
    text-align: left;
    overflow: hidden;
  }
  
  .title-bar {
    background-color: #e0e0e0; /* 标题栏背景颜色 */
    padding: 5px;
    margin: -10px -10px 10px -10px; /* 调整标题栏的边距 */
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .close-button {
    position: absolute;
    top: 5px;
    right: 10px;
    font-size: 20px;
    cursor: pointer;
  }
  
  .info-title {
    background-color: #d0d0d0; /* 标题背景色 */
    padding: 2px;
    cursor: pointer;
  }
  
  .info-content {
    background-color: #e8e8e8; /* 内容背景色 */
    padding-left: 0.1em; /* 内容开头空两格 */
  }
  
  .info-strong{
      font-weight: bold;
  }
  .indented-content {
    padding-left: 2em; /* 缩进 2 个空格 */
  }
  
  .info-clickable{
      cursor: pointer;
  }

  .menu-content {
    position: relative;
    top: 0;
    height: calc(100% - 30px); /* 减去标题栏的高度 */
    overflow-y: scroll; /* 添加垂直滚动条 */
    overflow-x:hidden;
    scrollbar-width: none;
  }
  </style>
  